import React, { Component } from "react";
import ShopListItem from '../shop_list_item/shop_list_item';
import Flexbox from 'flexbox-react';
import {observer} from 'mobx-react';

const componentWidths = {
    image: "26%",
    body: "56%",
    status: "19%"
};
const backgroundColor = {
    color: "rgba(0, 0, 0, 0.87)"
};

@observer
//and have the shop list widget render shop_list_columns to fit the screen
export default class ShopListRow1ItemWide extends Component {

    render() {
        return (
            <Flexbox width="100%" flexDirection="row">
                <Flexbox width="26.25%"></Flexbox>
                <Flexbox style={backgroundColor} width="48.5%">
                    <ShopListItem componentWidths={componentWidths} shop={this.props.shop}/>
                </Flexbox>
                <Flexbox width="26.25%"></Flexbox>
                <Flexbox width="1%"></Flexbox>
            </Flexbox>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list/shop_list_row_1_item_wide.jsx